import React, { useState } from 'react'
import { Table, Button, Form, Modal, Input, Avatar } from 'antd'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import CartoonSeriesForm from './CartoonSeriesForm'

const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const StyledInput = styled(Input)`
  width: 256px;
`

const CartoonSeries = ({
  cartoonSeries,
  allVideoPlaylists,
  addCartoonSeriesHandler,
  updateCartoonSeriesHandler,
  deleteCartoonSeriesHandler,
  removeFilesHandler
}) => {
  const [form] = Form.useForm()
  const [formForEdit] = Form.useForm()
  const [modalVisible, setModalVisible] = React.useState(false)
  const [cartoonSeriesItem, setCartoonSeriesItem] = React.useState(null)
  const [editModal, setEditModal] = React.useState(false)
  const [deleteModal, setDeleteModal] = React.useState(false)
  const [searchCartoonSeries, setSearchCartoonSeries] = React.useState(null)

  const [listCartoonSeries, setListCartoonSeries] = React.useState(null)
  const [coverImageFile, setCoverImageFile] = useState(null)
  const coverImageFileRef = React.useRef()

  React.useEffect(() => {
    const descriptiveCartoonSeries = cartoonSeries.map(series => {
      return {
        id: series.id,
        seriesName: series.seriesName,
        coverImage: series.coverImage,
        status: series.status,
        index: series.index,
        seasons: series.seasons,
        seasonsCount: series.seasonsCount,
        descriptionKZ: series.descriptionKZ,
        descriptionRU: series.descriptionRU,
        descriptionEN: series.descriptionEN,
        year: series.year,
        country: series.country
      }
    })
    let searchArray = descriptiveCartoonSeries

    if (searchCartoonSeries) {
      searchArray = searchArray.filter(series => {
        return series.seriesName?.toLowerCase().includes(searchCartoonSeries)
      })
    }

    setListCartoonSeries(searchArray)
  }, [cartoonSeries, searchCartoonSeries])

  const columns = [
    {
      title: '',
      width: '1%',
      render: item => (
        <div
          style={{
            background: item.status === 'active' ? '#44FB82' : '#D4D4D4',
            height: '60px',
            width: '20px',
            margin: '-10px'
          }}
        ></div>
      )
    },
    {
      title: 'Очередность',
      dataIndex: 'index',
      width: '5%'
    },
    {
      title: 'Обложка',
      width: '10%',
      render: item => {
        return (
          <>
            <Avatar shape="square" size={64} src={item.coverImage} />
          </>
        )
      }
    },
    {
      title: 'Название серии',
      dataIndex: 'seriesName',
      width: '25%'
    },
    {
      title: 'Количество сезонов',
      width: '10%',
      render: item => {
        return <>{item.seasonsCount || 0}</>
      }
    },
    {
      title: 'Действие',
      width: '20%',
      render: item => (
        <>
          <span>
            <Button
              type="link"
              onClick={() => {
                formForEdit.resetFields()
                setEditModal(true)
                setCartoonSeriesItem(item)
              }}
            >
              Редактировать
            </Button>
            <Button
              danger
              type="link"
              onClick={() => {
                setDeleteModal(true)
                setCartoonSeriesItem(item)
              }}
            >
              Удалить
            </Button>
          </span>
        </>
      )
    }
  ]

  return (
    <>
      <Table
        dataSource={listCartoonSeries}
        columns={columns}
        rowKey={item => item.id}
        title={() => (
          <StyledHeaderContainer>
            <StyledInput
              prefix={<SearchOutlined />}
              placeholder="Поиск серии"
              onChange={e => {
                setSearchCartoonSeries(e.target.value.toLowerCase())
              }}
            />

            <Button type="primary" onClick={() => setModalVisible(true)}>
              <PlusOutlined /> Новая серия
            </Button>
          </StyledHeaderContainer>
        )}
      />
      <Modal
        open={modalVisible}
        title="Новая серия мультиков"
        okText="Создать"
        cancelText="Отмена"
        onCancel={() => {
          form.resetFields()
          setModalVisible(false)
          setCoverImageFile(null)
          if (coverImageFileRef.current) {
            coverImageFileRef.current.value = null
          }
        }}
        onOk={() => {
          addCartoonSeriesHandler(
            form,
            setModalVisible,
            coverImageFile,
            allVideoPlaylists
          )
          setCoverImageFile(null)
          if (coverImageFileRef.current) {
            coverImageFileRef.current.value = null
          }
        }}
      >
        <CartoonSeriesForm
          setCoverImageFile={setCoverImageFile}
          allVideoPlaylists={allVideoPlaylists}
          coverImageFileRef={coverImageFileRef}
          form={form}
        />
      </Modal>
      {editModal && (
        <Modal
          open={editModal}
          title="Редактировать серию"
          okText="Сохранить"
          cancelText="Отмена"
          onCancel={() => {
            setEditModal(false)
            setCoverImageFile(null)
            if (coverImageFileRef.current) {
              coverImageFileRef.current.value = null
            }
          }}
          onOk={() => {
            updateCartoonSeriesHandler(
              formForEdit,
              cartoonSeriesItem.id,
              setEditModal,
              coverImageFile,
              allVideoPlaylists
            )
            setCoverImageFile(null)
            if (coverImageFileRef.current) {
              coverImageFileRef.current.value = null
            }
          }}
        >
          <CartoonSeriesForm
            form={formForEdit}
            id={cartoonSeriesItem.id}
            seriesName={cartoonSeriesItem.seriesName}
            descriptionKZ={cartoonSeriesItem.descriptionKZ}
            descriptionRU={cartoonSeriesItem.descriptionRU}
            descriptionEN={cartoonSeriesItem.descriptionEN}
            year={cartoonSeriesItem.year}
            country={cartoonSeriesItem.country}
            status={cartoonSeriesItem.status}
            index={cartoonSeriesItem.index}
            seasons={cartoonSeriesItem.seasons}
            setCoverImageFile={setCoverImageFile}
            allVideoPlaylists={allVideoPlaylists}
            coverImageFileRef={coverImageFileRef}
            removeFilesHandler={removeFilesHandler}
          />
        </Modal>
      )}
      {deleteModal && (
        <Modal
          open={deleteModal}
          title="Удалить серию"
          okText="Удалить"
          cancelText="Отмена"
          onCancel={() => {
            setDeleteModal(false)
          }}
          onOk={() => deleteCartoonSeriesHandler(cartoonSeriesItem.id, setDeleteModal)}
        >
          <h3>Вы действительно хотите удалить серию '{cartoonSeriesItem.seriesName}' ?</h3>
        </Modal>
      )}
    </>
  )
}

CartoonSeries.propTypes = {
  cartoonSeries: PropTypes.arrayOf(PropTypes.object).isRequired,
  addCartoonSeriesHandler: PropTypes.func.isRequired,
  updateCartoonSeriesHandler: PropTypes.func.isRequired
}

export default CartoonSeries